import './locales';
import reducer, { eventsTypes } from './duck';

export { Chat } from './containers';

export const chatModule = {
  reducer: reducer,
  eventsTypes: eventsTypes,
};
